<!-- 设置用户权限 -->
<template>
    <div>
        <el-dialog id="qx" :visible.sync="dataActionBox.showStatus" title="设置用户权限" append-to-body center
            :close-on-click-modal="false" width="80%" top="1rem">
            <div id="smProrange">
                <div class="cmTitle">生产范围</div>
                <div class="cmContent">
                    <el-button class="cmButton" @click="openRange('生产范围', 'smProrange')" type="info" plain
                        size="mini">选择生产范围</el-button>
                    <el-input type="textarea" v-model="smProrangeValues" readonly>
                    </el-input>
                </div>
            </div>
            <div id="smManrange">
                <div class="cmTitle">经营范围</div>
                <div class="cmContent">
                    <el-button class="cmButton" @click="openRange('经营范围', 'smManrange')" type="info" plain
                        size="mini">选择经营范围</el-button>
                    <el-input type="textarea" v-model="smManrangeValues" readonly>
                    </el-input>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="del">取消</el-button>
                <el-button type="primary" @click="saveUserJurisdiction()">保存</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="flag" title="选择" center :modal-append-to-body='true' id=csDia append-to-body
            :close-on-click-modal="false" width="70%">
            <div class="edit_dev">
                <el-transfer v-if="flag" filterable :filter-method="filterMethod" filter-placeholder="请输入范围名称"
                target-order="push"
                    v-model="value" :data="data" :titles="['未选择', '已选择']">
                </el-transfer>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="flag = false">取消</el-button>
                <el-button type="primary" @click="onsubmit()">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
    name: 'organizationalRange',
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                openMode: 'ltr' || 'rtl',
                boxTitle: '新增' || '编辑',
                actionType: 0, // 0新增，1修改
            },
            userInfo: {},
            smProrangeValues: "",//生产范围
            smProrangeID: [],//生产范围ID组
            smManrangeValues: "",//经营范围
            smProrangeID: [],//经营范围ID组
            flag: false,
            data: [],
            value: [],
            rangeObj: {
                p: [],
                m: [],
            },
            type: "",
            filterMethod(query, item) {
                return item.pinyin.indexOf(query) > -1;
            }
        };
    },
    //监听属性 类似于data概念
    computed: {
    },
    //监控data中的数据变化
    watch: {
        flag() {
            if (!this.flag) {
                this.value = []
                this.data = []
            }
        },
        "dataActionBox.showStatus"() {
            if (!this.dataActionBox.showStatus) {
                this.userInfo = {}
                this.smManrangeID = []
                this.smProrangeID = []
                this.smManrangeValues = ""
                this.smProrangeValues = ""
            }
        }
    },
    //方法集合
    methods: {
        del() {
            this.dataActionBox.showStatus = false
            this.$emit("close")
        },
        async saveUserJurisdiction() {
            if (this.smProrangeValues == "") {
                return this.$message.error("请选择生产范围")
            }
            if (this.smManrangeValues == "") {
                return this.$message.error("请选择经营范围")
            }
            const params = {
                manrangeIds: this.smManrangeID.join(','),
                ormId: this.userInfo.ormId,
                prorangeIds: this.smProrangeID.join(",")
            }
            const responseData = await this.$http.setOrmScope(params)
            console.log(responseData);
            if (responseData.status == 200) {
                this.$message.success("操作成功")
                this.dataActionBox.showStatus = false
                this.$emit("close")
            }
        },
        //获取生产/经营范围
        async getQueryScopeByType(type) {
            //type 范围类型0.生产范围1.经营范围
            let params = {
                type: type,
                ormId: this.userInfo.ormId,
            };
            let responseData = await this.$http.queryScopeByType(params);
            if (responseData.status == 200) {
                return responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
                return [];
            }
        },
        // 打开选择范围
        openRange(title, type) {
            this.value = [];
            this.data = [];
            this.type = type
            if (type == "smManrange") {//经营范围
                if (this.smManrangeID.length > 0) {
                    this.value = this.smManrangeID.map(Number)
                    console.log(this.value)
                }
                this.rangeObj.m.forEach((item) => {
                    this.data.push({
                        label: item.scopeName,
                        key: item.discId,
                        pinyin: item.scopeCode,
                    });
                });
            } else if (type == "smProrange") {
                if (this.smProrangeID.length > 0) {
                    this.value = this.smProrangeID.map(Number)
                }
                this.rangeObj.p.forEach((item) => {
                    this.data.push({
                        label: item.scopeName,
                        key: item.discId,
                        pinyin: item.scopeCode,
                    });
                });
            }
            this.flag = true;
        },
        openBox(oldData = '') {
            this.dataActionBox.showStatus = true
            this.userInfo = oldData
            this.smProrangeValues = this.userInfo.prorangeName
            this.smProrangeID = JSON.parse(JSON.stringify(this.userInfo.prorange.split(",")))
            this.smManrangeValues = this.userInfo.manrangeName
            this.smManrangeID = JSON.parse(JSON.stringify(this.userInfo.manrange.split(",")))
            console.log(this.smManrangeID,"smManrangeID")
            this.getQueryScopeByType(0).then((res) => {
                this.$set(this.rangeObj, "p", res);
            });
            this.getQueryScopeByType(1).then((res) => {
                this.$set(this.rangeObj, "m", res);
            });

        },
        onsubmit() {
            var value1 = JSON.parse(JSON.stringify(this.value))
            let id = []
            console.log(value1,"//////")
            var arr = []
            if (this.type == 'smManrange') {//经营范围
                this.value.forEach(item => {
                    this.rangeObj.m.forEach(item1 => {
                        if (item1.discId == item) {
                            arr.push(item1.scopeName)
                            id.push(item1.discId)
                        }
                    })
                })
                this.smManrangeID = id
                this.smManrangeValues = arr.join(",")
            } else {
                this.value.forEach(item => {
                    this.rangeObj.p.forEach(item1 => {
                        if (item1.discId == item) {
                            arr.push(item1.scopeName)
                            id.push(item1.discId)
                        }
                    })
                })
                this.smProrangeID = id
                this.smProrangeValues = arr.join(",")
            }
            this.flag = false
        },



    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {
    }, //生命周期 - 创建之前
    beforeMount() {
    }, //生命周期 - 挂载之前
    beforeUpdate() {
    }, //生命周期 - 更新之前
    updated() {
    }, //生命周期 - 更新之后
    beforeDestroy() {
    }, //生命周期 - 销毁之前
    destroyed() {
    }, //生命周期 - 销毁完成
    activated() {
    }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
#smManrange,
#smProrange {
    width: 100%;
    display: flex;
    padding-left: 83px;
    margin-bottom: 10px;
}

::v-deep #smManrange .el-form-item__content,
::v-deep #smProrange .el-form-item__content {
    width: 100% !important;
}

::v-deep #smManrange .el-textarea__inner,
::v-deep #smProrange .el-textarea__inner {
    width: 76% !important;
    margin-right: 20px;
    font-size: 12px;
}

.cmTitle {
    color: #606266;
    font-size: 14px;
    padding-top: 4px;
}

.cmContent {
    padding-left: 10px;
    width: 90%;
}

.cmButton {
    margin-bottom: 6px;
}

#csDia ::v-deep .el-dialog {
    min-width: 800px;
}
</style>